<template>
	
	<div class="content-area__inner content-area__list content-area__clients no-padding">
		
		<ContentAreaTitle :title="$route.meta.title">
			<template slot="actions">
				<el-button icon="el-icon-plus" @click="onClickNewClientButton" round>New Client</el-button>
			</template>
		</ContentAreaTitle>
		
		<!--<div class="card card--border card--no-padding">-->
			<el-table v-loading="$store.getters.loading" empty-text="We have no clients!" :data="clients">
				<el-table-column label="Name" :width="320">
					<template slot-scope="scope">
						<el-button type="text" @click="onClickEditClientButton(scope.row.data)">{{ scope.row.name }}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="description" label="Description"></el-table-column>
				<!--<el-table-column>
					<template slot-scope="scope">
						<el-button type="text" @click="onClickEditClientButton(scope.row.data)">Edit</el-button>
					</template>
				</el-table-column>-->
			</el-table>
		<!--</div>-->
		
		<el-dialog title="New Client" :visible.sync="newClient.visible" width="30%">
			
			<el-form :model="newClient">
				<el-form-item label="Client Name">
					<el-input v-model="newClient.name"></el-input>
				</el-form-item>
			</el-form>
			
			<span slot="footer" class="dialog-footer">
				<el-button @click="onClickNewClientPopupButton('cancel')">Cancel</el-button>
				<el-button :loading="$store.getters.loading" type="primary" @click="onClickNewClientPopupButton('confirm')">Save</el-button>
			</span>
			
		</el-dialog>
		
	</div>
	
</template>

<script>

	import ContentAreaTitle from "@/components/ContentAreaTitle";
	
	export default {
		
		name: "Clients",
		
		components: { ContentAreaTitle },
		
		data() {
			
			return {
				
				newClient: {
					visible: false,
					name: "",
				},
				
			}
			
		},
		
		methods: {
			
			onClickNewClientPopupButton(action) {
				
				if (action == "confirm") {
					
					if (!this.newClient.name) {
						
						this.$message("Please fill in the required fields before adding this client.");
						
					} else {
						
						// Loading...
						
						this.$store.commit("setLoading", {type: "start"});
						
						// Post!
						
						this.axios.post("clients", {
							
							name: this.newClient.name,
							
						}).then((response) => {
							
							if (response.statusText == "OK") {
								
								// Hide popup.
								
								this.newClient.visible = false;
								
								// Not loading anymore.
								
								this.$store.commit("setLoading", {type: "finish", message: "This client has been added."});
								
								// Refresh clients list.
								
								this.$store.dispatch("getApiData", { key: "clients" });
								
							} else {
								
								this.$store.commit("setLoading", {type: "error", message: "An unknown error occurred while adding this client."});
								
							}
							
						}).catch((e) => {
							
							this.$store.commit("setLoading", {type: "error", message: "An unknown error occurred while adding this client."});
							
						});
						
					}
					
				} else if (action == "cancel") {
					
					this.newClient.visible = false;
					
				}
				
			},
			
			onClickNewClientButton() {
				this.newClient.visible = true;
				this.newClient.name = "";
			},
			
			onClickEditClientButton(data) {
				this.$router.push({ name: "clients/client", params: { clientSlug: data.slug } });
			},
			
		},
		
		computed: {
			
			clients() {
				return this.$store.state.clients.map(function(data, i) {
					return {
						id: data.id,
						name: data.name,
						description: data.description ? data.description : "N/A",
						slug: data.slug,
						data: data,
					};
				});
			},
			
		},
		
		created() {
			this.$store.dispatch("getApiData", { key: "clients" });
		},
		
	}
	
</script>

<style scoped>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/Clients/Clients.vue